module.exports = __webpack_public_path__ + "img/driving_sm.885f9843.gif";